module.exports = __webpack_public_path__ + "img/03orange.6cba7c8c.gif";